import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIncreaseBadge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 23.9214C18.6274 23.9214 24 18.5664 24 11.9607C24 5.35499 18.6274 0 12 0C5.37259 0 0 5.35499 0 11.9607C0 14.5302 0.81287 16.9104 2.19627 18.8598L9.82237 11.4698L5.70036 7.47545H16.5004V17.9411L12.3784 13.9467L4.65452 21.4195C6.68444 22.9879 9.23285 23.9214 12 23.9214Z",
		fill: "#3FC5D6"
	})
});
export default SvgIncreaseBadge;
